<div class="modal-form-container">
    <div class="close-img-container" style="padding: 0px 9px;">
        <img src="../../../../../../../../assets/icons/x.svg" alt="close" (click)="closeModal()">
    </div>

    <!-- LOADING STEP -->
    <div style="padding: 0px 12px;">
        <div style="margin-top: 15px;" *ngIf="loading">
            <p-skeleton width="100%" borderRadius="6px" height="32px" />
        </div>
        <div style="margin-top: 10px;" *ngIf="loading">
            <p-skeleton width="100%" borderRadius="6px" height="44px" />
        </div>
        <div style="margin-top: 10px;" *ngIf="loading">
            <p-skeleton width="100%" borderRadius="6px" height="84px" />
        </div>
        <div style="margin-top: 30px;" class="skeleton-inline" *ngIf="loading">
            <div style="flex: 1;" *ngFor="let item of skeletonLoaders">
                <p-skeleton width="100%" borderRadius="6px" height="64px" />
            </div>
        </div>
        <div style="margin-top: 45px;" *ngIf="loading">
            <p-skeleton width="20%" borderRadius="6px" height="26px" />
        </div>
        <div style="margin-top: 14px;" *ngIf="loading">
            <p-skeleton width="100%" borderRadius="6px" height="119px" />
        </div>
        <div style="margin-top: 30px;" *ngIf="loading">
            <p-skeleton width="20%" borderRadius="6px" height="26px" />
        </div>
        <div style="margin-top: 14px;" *ngIf="loading">
            <p-skeleton width="100%" borderRadius="6px" height="74px" />
        </div>
    </div>

    <div class="modal-header-container" *ngIf="!loading">
        <div class="modal-header-title">
            <p *ngIf="CurrentStep !== Step.Step4">{{'EDIT_SERVICES.HEADER.0' | translate}}</p>
            <p *ngIf="CurrentStep === Step.Step4">{{'EDIT_SERVICES.HEADER.9' | translate}}</p>
        </div>

        <div class="modal-header-description" *ngIf="CurrentStep !== Step.Step4">
            <p>{{'EDIT_SERVICES.HEADER.1' | translate}} </p>
        </div>

        <div class="info-notification" style="margin-top: 22px;" *ngIf="CurrentStep !== Step.Step4">
            <img src="assets/icons/information-circle-2.svg" alt="Info icon" />
            <div>
                <p class="text-info-notification">
                    {{'EDIT_SERVICES.HEADER.2' | translate}}
                </p>
            </div>
        </div>
    </div>

    <div class="navbar-container" *ngIf="!loading">
        <div class="step" [ngClass]="{'completed': step.Completed, 'active': step.Active }" (click)="setStep(step.Id)"
            *ngFor="let step of navbarSteps">
            <div class="circle" *ngIf="step.Completed">
                <span class="checkmark">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 12.5L10 16.5L18 8.5" stroke="white" stroke-width="2.8" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </span>
            </div>
            <div class="circle active-circle" *ngIf="step.Active"></div>
            <div class="circle disable-circle" *ngIf="!step.Active && !step.Completed"></div>

            <span class="label">{{step.Title}}</span>
        </div>
    </div>

    <app-vehicle-route-info-step #VehicleRouteComponent
        *ngIf="!loading && ServiceDetails && ServiceForm && CurrentStep == Step.Step1" [LoadingRoutes]="LoadingRoutes"
        [VehicleInformation]="ServiceDetails.VehicleInformation"
        [AddressForm]="addressDataFormGroup"></app-vehicle-route-info-step>

    <app-day-contact-info-step *ngIf="!loading &&  ServiceDetails && CurrentStep == Step.Step3"
        [DayContactForm]="dayContactDataFormGroup" [PrincipalProductId]="PrincipalProductId" [ServiceForm]="ServiceForm"
        [ServiceDetails]="ServiceDetails"
        (updateServiceDetailsEmitter)="updateServiceDetails($event)"></app-day-contact-info-step>

    <app-resume-info-step *ngIf="!loading && ServiceDetails && CurrentStep == Step.Step4"
        [LoadingSimulation]="LoadingSimulation" [ServiceForm]="ServiceForm"></app-resume-info-step>

</div>


<!-- EL STEP 2 TIENE SU PROPIO FOOTER -->
<app-service-info-step *ngIf="!loading && ServiceDetails && ServiceForm && CurrentStep == Step.Step2"
    [ToppingList]="Toppings" [ServiceForm]="ServiceForm" (nextStepEmitter)="setStep(CurrentStep + 1)"
    (backStepEmitter)="backStep()"></app-service-info-step>



<!-- [style.padding]="loading ? '10px 20px' : '10px 12px'" -->

<div class="footer-container" *ngIf="CurrentStep != Step.Step2">

    <div *ngIf="loading">
        <p-skeleton width="478px" borderRadius="6px" height="48px" />
    </div>

    <!-- 
    <div *ngIf="SaveLoading" class="loading-spinner-container">
        <img src="../../../../../../../../assets/gifs/loading-spinner.gif" alt="loading" />
    </div> -->

    <button *ngIf="!loading && CurrentStep != 1" class="button-white button-padding-11 flex-1"
        (click)="backStep()">{{'EDIT_SERVICES.HEADER.3' | translate}}</button>

    <button *ngIf="!loading" [ngClass]="{
            'button-disable':
              (CurrentStep === 1 && (!isAddressDataStepValid || (VehicleRouteComponent && VehicleRouteComponent.ShowProductErrorMessage))) ||
              (CurrentStep === 3 && !isContactDataStepValid) ||
              LoadingSave || LoadingSimulation
          }" class="button-black button-padding-11 button-image flex-1" (click)="setStep(CurrentStep + 1)">
        {{CurrentStep
        < 4 ? ('EDIT_SERVICES.HEADER.4' | translate) : ('EDIT_SERVICES.HEADER.10' | translate) }} <img
            *ngIf="CurrentStep < 4" src="../../../../../../../../assets/icons/arrow-sm-right.svg" alt="arrow-right" />
    </button>

    <div *ngIf="LoadingSave">
        <img style="width: 30px;" src="../../../../../assets/gifs/loading-spinner.gif" alt="">
    </div>



</div>